import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { GlobeIcon, Popover, QuestionIcon, Strong, Text } from 'main/ui'
import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'
import { SpaceBetweenFlexSpan } from './Basics.styles'

import styled from '@emotion/styled'
import { spacing } from 'main/ui'

const PRE = `${i18nKeyPrefix}-BASICS-SPOKENLANGUAGES`

interface IProps {
  spokenLanguages: string[] | null
}

const TooltipIconContainer = styled.div`
  display: inline-block;
  cursor: pointer;
  height: 17px;
  margin-left: ${spacing.majorScale(1)}px;
  margin-top: ${spacing.minorScale(1)}px;
  vertical-align: middle;
  width: 17px;
`

const PopoverBodyContainer = styled.div`
  max-width: 300px;
  padding: ${spacing.majorScale(1)}px ${spacing.majorScale(2)}px;
`
export default function SpokenLanguages(props: IProps) {
  const { spokenLanguages } = props
  const { t } = useTranslation(NAMESPACE)

  const [isTooltipOpen, setIsTooltipOpen] = React.useState<boolean>(false)

  return (
    <Bullet icon={<GlobeIcon />}>
      <SpaceBetweenFlexSpan>
        <Strong>{t(`${PRE}-TITLE`)}</Strong>
        <Popover
          body={popOverBody()}
          isOpen={isTooltipOpen}
          onRequestClose={() => setIsTooltipOpen(false)}
        >
          <TooltipIconContainer onClick={() => setIsTooltipOpen(true)}>
            <QuestionIcon />
          </TooltipIconContainer>
        </Popover>
      </SpaceBetweenFlexSpan>
      <Text muted>
        {(spokenLanguages && spokenLanguages.join(', ')) || t(`${PRE}-NOTAVAILABLE`)}
      </Text>
    </Bullet>
  )
}

const popOverBody = () => {
  const { t } = useTranslation(NAMESPACE)

  return (
    <PopoverBodyContainer>
      <Text>{t(`${PRE}-TOOLTIP-TEXT`)}</Text>
    </PopoverBodyContainer>
  )
}
